import { render, staticRenderFns } from "./EditShangbiao.vue?vue&type=template&id=5f6b158d&scoped=true"
import script from "./EditShangbiao.vue?vue&type=script&lang=js"
export * from "./EditShangbiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6b158d",
  null
  
)

export default component.exports